var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _line, _path8, _path9, _path10, _path11, _path12, _path13, _line2, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _line3, _line4, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 727.2 543.5",
    style: {
      enableBackground: "new 0 0 727.2 543.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4F6F9;}\n\t.st1{fill:#F5CA99;}\n\t.st2{fill:none;stroke:#132144;stroke-width:7;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{fill:#132144;}\n\t.st4{fill:#377DFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280,87.2c1.1,27.1,2.2,59.8,2.7,89.8l0,0c0,0,33.2-22.3,55.8-31c2.1-0.8,4.3-1.2,6.5-1.2l1.4-2.1 c3.5-7.6,7.4-15.1,11-22.8c-5.5-0.8-6.1-7.9-6.1-12.9c0-1.7,0-3.5,0.1-5.2l0,0c-9.5-2.4-15.5-12.3-11.7-24.1 c2.9-9,11.2-15.4,20.4-18c2.9-7.5,6.5-14.7,10.8-21.6c-10.9-4.1-22.6-5.8-34.2-5c-2.9,0.2-5.8,0.6-8.7,1.1 c-4.9-0.1-9.8,0.1-14.7,0.7c-17.1,2-33.6,7-49.6,13.5C275.8,54.7,279.4,71.8,280,87.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M468.5,122.4c-2.9-0.6-5.7-1.5-8.4-2.6c-2.5,5.8-5,11.4-7.2,16.4c-6.6,15.1-21.6,49.8-21.6,49.8l-0.3,0.7 c0.8,0.7,1.4,1.4,1.8,1.7c5,5,5.5,22,5.6,50s-0.5,87.6,8.3,120.1c4.9,18,10,50.4,25.7,61.8c23.7,17.3,47.3-18.1,55.8-36.9 c7.3-16,11-32.1,16.2-48.6c2.7-8.7,4.5-15.4,11.7-17c0,0,12.6-51.8,17.1-75.4c4-21.5,8.7-49.6,29.2-61.8c8.3-5,26.7-13.8,33.3-2.1 c5.9-5.8,17.3-7.4,21.9-0.7c-0.2-19.4-7.6-38-20.9-52.2c-9.2-10-20.8-17.5-33.7-21.8c-14.7-4.8-30.5-3.8-45.4-0.1 C528.3,111.1,499.9,129.2,468.5,122.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M720.4,382.8c-2.8-15.2-11.9-28.2-23.2-38.4c-12.9-11.6-27.5-21.5-41.3-31.9l-10.7-8l-10.7,49.3l-0.1,0.4 c1.8,2,3.4,4.2,4.7,6.5c11.3,20.6,5.5,54.8-2,75.4c-2,5.4-7.3,14.9-13.5,22.2c1.5,7.8,0.2,17.3-2.5,26.9c8.6-0.8,17.1-2.4,25.4-4.5 c28.3-7.6,56.2-25.1,68.2-52.8C721,413.5,723.2,398.1,720.4,382.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M725.8,238.2c-3.8-8.6-13.8-12.5-22.4-8.8c-4.2,1.8-7.5,5.3-9.1,9.5l-1.6,4.2c-2.1-0.8-5-1.9-8.5-3.2 c-2.3-0.9-4.9,0.3-5.8,2.6s0.3,4.9,2.6,5.8l8.4,3.2l-1.1,2.8c-3.4,8.8,1,18.6,9.8,22c8.8,3.4,18.6-1,22-9.8l5.9-15.3 C727.7,247.1,727.6,242.4,725.8,238.2z M717.7,248l-5.9,15.3c-1.6,4.1-6.3,6.2-10.4,4.6c-4.1-1.6-6.2-6.3-4.6-10.4l5.9-15.3 c1.2-3.1,4.2-5.1,7.5-5.1c4.4,0,8,3.5,8,8C718.3,246,718.1,247.1,717.7,248z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M282.8,177c0,0,33.2-22.3,55.8-31c10.4-4,22.5,3.2,33,7.1c14.7,5.6,28.6,11.6,42,19.7 c7.4,4.5,17.3,13.5,19.4,15.6c5,5,5.5,22,5.6,50s-0.5,87.6,8.3,120.1c4.9,18,10,50.4,25.7,61.8c23.7,17.3,47.3-18.1,55.8-36.9 c7.3-16,11-32.1,16.2-48.6c3.4-10.8,5.3-18.5,18-17.2c10.2,1.1,24,8.3,33,13c14.6,7.7,35.1,14.6,43.6,30c11.3,20.6,5.5,54.8-2,75.4 c-4.5,12.4-26.6,46.2-36.2,25c-4.2-9.2,6.2-22.9,15.7-15.5c20.4,16.1-5.1,68.7-15.1,82.1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M332.5,164.7c-0.5,12.4,4.4,43.7,15,52.3c16.3,13.2,39-17.2,48.9-26.2c-0.5,10.9-6.8,38,5.1,44.5 c8.5,4.6,19-4,25-8.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M378.5,226.7c-9.1,10.6-18.2,21.7-27.1,37.3s-14.7,28-11,36.9c2.6,6.3,10.8,3.1,13.2,9.9 c3.3,9.3-13.5,25-16.6,32.6c-3.6,8.8-6.2,18-3.5,26.5c2.2,7.1,6.5,10.8,6,19c-0.4,8.9-17,34-17,39.8"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 364.5,
    y1: 284.7,
    x2: 370.5,
    y2: 285.7
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M349.5,353.7c1.4,0.4,2.5,0.7,4,1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M337.5,423.7h5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M388.5,327.7c9.4,6.9,19.5,12.3,28,20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M413.5,329.7c-1.2,13.7-6.3,28.9-11,42"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M404.5,324.7c-1.4,8.8-10,33.4-10,33.4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M556.2,317.9c0,0,12.6-51.8,17.1-75.4c4-21.5,8.7-49.6,29.2-61.8c8.3-5,26.7-13.8,33.3-2.1 c7.2-7,22.6-7.9,23.9,5c9.3-5.6,18.3-0.3,18,11c25.4,1.1,9.8,48.5-3,58.2c-9.3,6.9-17.3,4.4-22-1.2"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 634.5,
    y1: 353.7,
    x2: 656,
    y2: 254.7
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M566.5,277.7c15.7,0,30.6,1.1,44,5.8s27.5,12.3,33,20.3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M608.5,198.7c0.4,3.5-0.1,9.1,0,11"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M635.7,178.6c5.8,8.6,8.4,18.8,7.6,29.1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M659.6,183.6c2.8,13.6,4.8,35.5-1.1,46.8c-4.8,9.2-18.6,17.9-29.2,12.3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M677.6,194.6c0,29-15.3,75.5-43.1,49.8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M600.4,210.9c-26.8-9.3-65-23.1-65.4-23.2c-2.3-0.9-4.9,0.2-5.9,2.5c-0.9,2.3,0.2,4.9,2.5,5.9 c0.1,0,0.2,0.1,0.3,0.1l2.8,1l-4.2,9.2c-1,2.3-0.1,4.9,2.2,6c0,0,0,0,0,0c0.6,0.3,1.2,0.4,1.9,0.4c1.8,0,3.4-1,4.1-2.6l4.5-9.9 l0.3,0.1c-4.3,8.5-4.1,9.7-3,11.6c0.8,1.4,2.3,2.2,3.9,2.2c0.8,0,1.6-0.2,2.3-0.6c1.3-0.7,2.1-2,2.2-3.5c0.4-1.1,1.7-3.9,3.2-6.7 c13.3,4.8,31,11,45.3,16c2.3,0.8,4.9-0.4,5.8-2.8S602.8,211.8,600.4,210.9L600.4,210.9z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M346.5,142.7c6.4-13.9,14.2-27.8,19.1-42.6c-16.3,7.7-31.4-5.3-25.8-22.4c5.2-16,27.5-24.1,41.5-16.1 c5.7-19.1,21-44.4,42.2-46.9c28.7-3.3,49.4,22.1,64.9,42.4c7.6,10.2,14.3,21,20,32.4c-10.7-1.5-36.7-5.7-36.7-5.7 c-2.2,16.4-12.1,37-18.7,52.4c-6.6,15.1-21.6,49.8-21.6,49.8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M420.5,91.7c2,5.1,6.5,11.4,13,11.4"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 429.5,
    y1: 63.7,
    x2: 432.5,
    y2: 69.7
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 444.5,
    y1: 62.7,
    x2: 448.5,
    y2: 69.7
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M369.5,80.7c-2.8-0.7-13.5-0.9-11-1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M351.4,101.8c-0.1,1.7-0.1,3.5-0.1,5.2c0,5,0.6,12.1,6.1,12.9c3.1-6.4,5.8-13.1,8.1-19.8 C361.2,102.3,356.2,102.9,351.4,101.8z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M488.2,33.8c-15.1-4.6-23.4-20.2-36.6-28c-13-7.6-30.2-8.6-41.7,2.3c-1.3,1.3-2.5,2.7-3.5,4.1 c-0.5,0.7-0.8,1.2-1.1,1.6c-5.1-1.2-10.4-0.5-15,2c-7.1,3.9-12.3,11.7-16.8,18.3c-5.4,8-9.9,16.6-13.4,25.6 c6.2-1.9,12.9-1.6,18.9,0.8c0.6,6.9,2.3,13.6,5.1,19.9c1.2,2.8,5.6,2.5,6.9,0c8.7-16.1,28.6-32.2,26.3-51.5 c22.3,8.5,45.9,12.9,69.8,12.8C491.7,41.6,492.5,35.1,488.2,33.8z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M257.9,535.8c-20.4,2.1-65,3.8-106,3.8s-86.7,0.8-105.7,0.2s-37-7-38.3-37.2s-2-78.3-2.1-108.5 c-0.2-70.4-2.3-140.7-2.3-211.3c0-36.8-0.1-72.4,6.1-108.5C12.8,55.3,30.7,49,48.2,45.9c29.9-5.2,47.7-3.2,78-4.8 c43.8-2.2,110.7,3.3,129.3,5s23.7,22.6,24.5,41c1.5,36.3,2.9,82.8,3,119.1c0.2,74.9-1.4,150.7,2.6,225.3c1.4,26.2,0.3,58.9,0.3,70.3 S278.3,533.6,257.9,535.8z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.6,45.5c-22.7,9.6-27.3,29.1-28.3,57.5s-0.5,83.9-0.5,139.3s0.5,116.7,0.5,155.7s-0.1,77.8,1.7,103.7 s14.7,38.2,33.3,38.3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M224.9,331.4c-2.6-48.8-5.5-54.1-6.7-56.1c-3.5-6.2-9.8-9.5-16.8-11.2c0-2.2-0.1-4.3-0.1-6.4 c-0.3-21.9-0.4-39.2-20.1-53c-8-5.6-24.5-8.5-41.8-1.5c-22.7,9.2-23.1,34.4-23.4,52.8c-0.1,3.8-0.1,7.5-0.4,10.6l-0.8,0.2 c-16.9,4-17.8,26.4-18.5,42.8c-0.1,2.6-0.2,5.1-0.4,7.4c-1.8,25-1.9,63.3-1.9,63.6c0,1.9,1.5,3.4,3.3,3.5c14,0.7,27,1.1,39.9,1.1 c27.2,0,53.6-1.5,86-3.5c1.9-0.1,3.3-1.7,3.3-3.6C226.7,378,226.2,355.2,224.9,331.4z M125.2,256.2c0.3-17.6,0.6-37.6,17.8-44.6 c10-4.1,25-5.3,33.2,0.5c15.9,11.1,16.1,24.9,16.3,45.7c0,1.6,0,3.2,0.1,4.9c-2-0.2-4-0.2-5.8-0.2c-10.2,0-43.2,0.9-61.8,2.8 C125.1,262.5,125.1,259.4,125.2,256.2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M132.2,268.6c-6.8,12.6-3.9,72.3-4.7,113.2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M181.6,320.2c6.6-0.6,11.6-6.2,11.5-12.8c0-6.6-4.5-11.6-11.4-12.6c-4.1-0.6-8.3-0.6-12.4-0.1l-1.2,0.1 c-7.2,0.7-12.4,6.1-12.3,12.8c0.1,6.3,4.7,11.6,10.9,12.5c-3.5,12.8-8.9,29.2-9,29.4c-0.6,1.8,0.4,3.8,2.2,4.4 c0.4,0.1,0.7,0.2,1.1,0.2h0.1l25.8-0.8c1.9,0,3.4-1.7,3.4-3.6c0-0.3-0.1-0.6-0.1-0.9C190,348.8,185.2,332.7,181.6,320.2z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M623.5,267.7c8.2-8.7,8.4-33.6-4.7-38.8c9.2-0.6,31.9,1.3,34.7-11.3c1.8-8-9.8-10.4-16.5-10.9 c-18.7-1.4-43.2,5.2-52.2,23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.8c3dd1ea4be4be60eb05514300c3903e.svg";
export { ForwardRef as ReactComponent };